// extracted by mini-css-extract-plugin
module.exports = {"checkItemsContainer":"styles_checkItemsContainer__-2Wx7","checkboxContainer":"styles_checkboxContainer__3J7H7"};